module.exports = __webpack_public_path__ + "static/media/bicoBronzeNipple.e888c3ed.png";